<!-- <p>manage-version works!</p> -->
@if (showDeleteConfirmation) {
  <common-delete-version [version]="selectedVersion" (cancelDelete)="cancelDelete($event)" (confirmDelete)="confirmDelete($event)"/>
}
<div class="versioning-panel-main modal-popup" [ngStyle]="{'display': showManageVersionPanel ? 'block' : 'none'}">
  <div class="versioning-inner">
    <header>
      <div class="icon-close float-right d-none d-lg-block" title="Close Panel" (click)="closeManageVersionPopup()">esc<span class="Neueclosefilled pl-1"></span></div>
      <h2><span class="NeueBack mr-1 d-lg-none" (click)="closeManageVersionPopup()"></span>Manage Versions ({{versionImplementation?.versionsList?.totalVersions}})</h2>
      <p>Older versions of <strong>'{{universalService?.selectedFile?.objectName}}'</strong> will be deleted once 100 versions are reached. Versions are listed based on the order of upload/modification on JioAICloud.</p>
    </header>
    <!-- File Versions -->
    <div class="file-versions-main">
      @if (versionImplementation.versionsList.totalVersions > 0) {
        <div>
          @for (version of versionImplementation.versionsList.objVersions; track version) {
            <div class="row m-0 p-0 pt-3 pb-3 versionRow" (click)="openPreviewOfCurrentVersion(version)">
              <div class="col-11 p-0">
                <div class="v-file-name-wrap">
                  <span class="version"><em>{{version?.displayVersion}}: </em></span> <span class="v-file-name">{{version?.objectName}}</span>
                </div>
                <!--  -->
                <div class="v-date-name-wrap">
                  <span class="date">{{version?.customCreatedDate}} - </span><span class="name">{{version?.versionCreatedBy.firstName}} {{version?.versionCreatedBy.lastName}}</span>
                  <!-- Status -->
                  @if (version.isCurrentVersion) {
                    <span class="current">Current</span>
                  }
                </div>
              </div>
              <div class="col-1 p-0 pr-1 more-menu-col">
                <span class="NeueMore_Options dropdown-toggle" data-toggle="dropdown" id="dropdownMenuButton" aria-expanded="false" (click)="toggleMoreOptions(version)"></span>
                <div class="dropdown">
                  <div class="dropdown-menu manage-version-dropdown-menu">
                    <ul class="version-menu-options">
                      @for (option of contextMenu; track option) {
                        <li (click)="decideAction(option.onClick)"><span class="{{option.iconName}} mr-2"></span>{{option.menuItem}}</li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
      @if (versionImplementation.versionsList.totalVersions == 0) {
        <div>
          <span class="no-versions">No versions found</span>
        </div>
      }

    </div>
  </div>

  <div class="spinner_loader">
    <div class="small_loader"></div>
  </div>
</div>